import React from "react";

/*
 * Icon with 3 inline dots
 *
 */
const DotsIcon = () => {
  return (
    <div className="icon__dots">
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </div>
  );
};

export default DotsIcon;
